<template>
  <div class="notifications">
    <div class="warningBlock" v-if="appMode === 'staging'">
      Aplicação em modo de testes. Toda a informação é fictícia.
    </div>
    <div
      class="warningBlock"
      v-if="sendMessages.value === 'false' && $route.name !== 'MessageSettings'"
    >
      O envio automático de mensagens encontra-se inactivo.
      <router-link class="small" :to="{ name: 'messageSettings' }" tag="button"
        >Alterar</router-link
      >
    </div>
    <div class="warningBlock" v-if="offline">
      Ligação à internet perdida. Verifique a ligação do seu dispositivo.
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'NotificationsComponent',
  data: function () {
    return {
      sendMessagesId: '',
      appMode: import.meta.env.VITE_MODE,
    }
  },
  computed: {
    ...mapState({
      settingsById: (state) => state.settings.listById,
      offline: (state) => state.offline,
    }),
    ...mapGetters({
      isLoggedin: 'auth/isLoggedin',
    }),
    sendMessages() {
      if (typeof this.settingsById[this.sendMessagesId] !== 'undefined') {
        return this.settingsById[this.sendMessagesId]
      }
      return true
    },
  },
  methods: {
    ...mapActions({
      getSettingsList: 'settings/list',
      setOffline: 'setOffline',
    }),
    findSendMessagesId() {
      Object.keys(this.settingsById).find((id) => {
        const setting = this.settingsById[id]
        if (setting.name === 'SendMessages') {
          this.sendMessagesId = id
          return true
        }
        return false
      })
    },
    setOfflineLocal() {
      this.setOffline(true)
    },
    setOnlineLocal() {
      this.setOffline(false)
    },
  },
  created() {
    if (
      this.$route.name !== 'login' &&
      this.$route.name !== 'notFound' &&
      this.$route.name !== 'recover'
    ) {
      this.findSendMessagesId()
    }
    window.addEventListener('offline', this.setOfflineLocal)
    window.addEventListener('online', this.setOnlineLocal)
  },
  unmounted() {
    window.removeEventListener('offline', this.setOfflineLocal)
    window.removeEventListener('online', this.setOnlineLocal)
  },
}
</script>

<style lang="scss" scoped>
.notifications {
  text-align: center;
  .warningBlock {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
